import { ReactElement } from "react";

export function Modal({
    id,
    children,
    style,
}: {
    id: string;
    children: ReactElement;
    style: string;
}) {
    return (
        <dialog id={id} className="modal" data-theme="corporate">
            <div className={"modal-box bg-gray-50 shadow-sm border " + style}>
                {children}
            </div>

            <form method="dialog" className="modal-backdrop">
                <button>close</button>
            </form>
        </dialog>
    );
}
